<template>
  <div v-if="modesBreakdownDataset">
    <container-section>
      <template v-slot:default>
        <div>
          <div
            class="control-values position-sticky mb-4"
            :style="comparePage ? 'top: 80px' : 'top: 3px'"
          >
            <div class="d-flex align-items-center justify-content-end">
              <input
                class="d-none"
                type="radio"
                :id="'toggle-to-number-survey-' + surveyId"
                value="n"
                v-model="shownValueType"
              />
              <label
                class="
                  mx-1
                  d-flex
                  align-items-center
                  justify-content-center
                  cursor-pointer
                "
                :for="'toggle-to-number-survey-' + surveyId"
                >N</label
              >
              <input
                class="d-none"
                type="radio"
                :id="'toggle-to-percentage-survey-' + surveyId"
                value="p"
                v-model="shownValueType"
              />
              <label
                :for="'toggle-to-percentage-survey-' + surveyId"
                class="
                  mx-1
                  d-flex
                  align-items-center
                  justify-content-center
                  cursor-pointer
                "
                >%</label
              >

              <div
                class="mx-2 text-capitalize filter-button p-0"
                :class="{ 'active-btn': activeBtn }"
              >
                <span class="btn-content px-4" @click="activeBtn = !activeBtn"
                  >Mood Breakdown</span
                >
              </div>
            </div>
          </div>
          <div
            class="mb-4"
            v-for="(surveyQuestion, index) of modesBreakdownDataset"
            :key="'q' + index"
            :id="`modes-breakdown-question-${surveyId}-${index}`"
          >
            <h4
              class="question-text my-4"
              :class="{
                'compare-page-question': comparePage,
                'contains-placeholder':
                  comparePage && surveyQuestion.containsPlaceholders,
              }"
            >
              {{ surveyQuestion.questionHeader }}
            </h4>
            <ul class="answers-list list-unstyled text-info mb-4">
              <li
                v-for="(answer, answerIndex) of sortAnswers(
                  surveyQuestion.choices
                )"
                :key="'answerBreakdown' + answer.choiceMode + answerIndex"
              >
                <answer-breakdown
                  :answer="answer"
                  :breakdown-mode="activeBtn"
                  :total-count="surveyQuestion.totalCount"
                  :shown-value-type="shownValueType"
                  :answer-index="answerIndex"
                  groupName="experience"
                  :personaIsActive="false"
                ></answer-breakdown>
              </li>
            </ul>
            <hr v-if="index !== modesBreakdownDataset.length - 1" />
          </div>
        </div>
      </template>
    </container-section>
  </div>
</template>

<script>
import AnswerBreakdown from "./answer-breakdown.vue";

export default {
  name: "ModesBreakdown",
  components: {
    AnswerBreakdown,
  },
  props: {
    modesBreakdownDataset: {
      type: Array,
      required: true,
    },
    surveyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activeBtn: false,
      shownValueType: "n",
    };
  },
  computed: {
    comparePage() {
      return this.$route.path.includes("compare");
    },
  },
  methods: {
    sortAnswers(answers) {
      return [...answers].sort((a, b) => a.choiceId - b.choiceId);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.question-text {
  line-height: $line-height-28;
  color: $color-white;
  letter-spacing: 0;
  font-weight: $font-weight-semiBold;
  font-size: $font-size-28;
  min-height: 2.632rem;

  &.compare-page-question {
    min-height: 4.375;
    font-size: $font-size-26;
  }

  &.contains-placeholder {
    min-height: 115px;
    max-height: 115px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

hr {
  background-color: $color-grey-60;
  height: 2px;
}

.control-values {
  min-width: 4.375rem;
  top: 0;
  z-index: 1;

  label {
    border: $border-white-1;
    border-radius: 1.875rem;
    width: 2.8125rem;
    height: 2.3125rem;
    color: $color-white;
    transition: $transition-400ms;
    background-color: $color-grey-100;

    &:hover {
      background-color: $color-white;
      color: $color-grey-100;
    }
  }

  .btn-content {
    min-height: 2.3125rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  input:checked + label {
    background: $color-white;
    color: $color-grey-100;
  }
}

.active-btn {
  background-color: $color-white;
  color: $color-grey-100;
}
</style>
